/**
 * TASK TL19 — single source of truth for which Book type / Size combinations are
 * purchasable, shared by the product page (assets/product-hero.js) and the cart Edit
 * modal (assets/cart-edit-modal.js) so the two can never offer two different answers
 * for the same product (DEF-70: Edit let "Saddle stitch / 12x12" through when the
 * product page itself blocks it).
 *
 * A classic (non-module) script attached to `window.FSBVariantAvailability`, not an ES
 * export: product-hero.js is a classic deferred script and cart-edit-modal.js is an ES
 * module, and this repo has no bundler to give them a shared import. Loaded before both
 * via a plain `<script src>` tag (sections/product-hero.liquid, sections/cart.liquid).
 */
(function () {
  function variantMatchesSelection(variant, selected) {
    return (
      (!selected[0] || variant.option1 === selected[0]) &&
      (!selected[1] || variant.option2 === selected[1]) &&
      (!selected[2] || variant.option3 === selected[2])
    );
  }

  function findVariant(variants, selected) {
    return (variants || []).find(function (variant) {
      return variantMatchesSelection(variant, selected);
    }) || null;
  }

  // Is there a purchasable variant for `value` at `optionIndex`, given whatever is
  // already picked at the other option indexes (those stay wildcards when unset)?
  // `variant.available` absent/undefined is treated as available, matching Shopify's
  // own JSON (untracked-inventory variants carry no `available` key at all).
  function isOptionValueAvailable(variants, optionIndex, value, selected) {
    var candidate = (selected || []).slice();
    candidate[optionIndex] = value;

    return (variants || []).some(function (variant) {
      return variantMatchesSelection(variant, candidate) && variant.available !== false;
    });
  }

  // The cheapest variant that is actually purchasable right now, falling back to the
  // cheapest variant overall if nothing is available (a fully sold-out product still
  // needs a selection, just one whose CTA will correctly render disabled).
  function getCheapestAvailableVariant(variants) {
    var list = variants || [];
    var available = list.filter(function (variant) { return variant.available !== false; });
    var pool = available.length ? available : list;

    return pool.reduce(function (cheapest, variant) {
      if (!cheapest) return variant;
      return Number(variant.price) < Number(cheapest.price) ? variant : cheapest;
    }, null);
  }

  window.FSBVariantAvailability = {
    findVariant: findVariant,
    isOptionValueAvailable: isOptionValueAvailable,
    getCheapestAvailableVariant: getCheapestAvailableVariant
  };
})();
